var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcconMenuAzureAdConfig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Azure",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3320",
    d: "M20591 22454.5a2.511 2.511 0 0 1 .146-.844l-2.437-1.963a2.5 2.5 0 1 1-.477-4.58l3.178-4.24a2.472 2.472 0 0 1-.41-1.369 2.5 2.5 0 1 1 4.592 1.369l3.178 4.24a2.5 2.5 0 1 1-.479 4.578l-2.437 1.965a2.5 2.5 0 1 1-4.854.844zm1.234-2.152a2.47 2.47 0 0 1 .418-.2v-8.1l-3.059 4.082a2.513 2.513 0 0 1 .238 2.281zm2.533 0 2.4-1.937a2.5 2.5 0 0 1 .238-2.277l-3.062-4.084v8.1a2.651 2.651 0 0 1 .425.194z",
    transform: "translate(-20581.5 -22436)",
    style: {
      fill: "#778187"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcconMenuAzureAdConfig);
export default __webpack_public_path__ + "static/media/IcconMenuAzureAdConfig.195e6ddd2fd0f662d5e45a0129963eae.svg";
export { ForwardRef as ReactComponent };